import {
  TransactionQuery,
  TransactionInfoQuery,
  TXFileType,
  TransactionInfoResult,
  TransactionQueryResult,
  TransactionExecute,
  TransactionExecuteResult,
  BizumRefundResult,
  ManualCloseResponse,
  CommerceCodes,
  CommerceCodesRequest,
  ManualCloseRequest
} from "../types";
import * as util from "@/util";
import * as download from "@/util/download";
import { postServiceCall, downloadCall } from "./base";
import store from "../store";

export async function getTransactionData(query: TransactionQuery): Promise<TransactionQueryResult> {
  return await postServiceCall(query.pageNum ? "transactionPagedData" : "transactionData", {
    ...query,
    language: store.state.lang.key
  });
}

export async function modifyTransaction(query: TransactionExecute): Promise<TransactionExecuteResult> {
  return await postServiceCall("transactionExecute", {
    ...query,
    language: store.state.lang.key
  });
}

export async function getCommerceCodes(query: CommerceCodesRequest): Promise<CommerceCodes[]> {
  return await postServiceCall("commerceCodes", {
    ...query,
    language: store.state.lang.key
  });
}

export async function executeManualClose(query: ManualCloseRequest): Promise<ManualCloseResponse> {
  return await postServiceCall("executeManualClose", {
    ...query,
    language: store.state.lang.key
  });
}

export async function newTransaction(query: TransactionExecute): Promise<TransactionExecuteResult> {
  return await postServiceCall("transactionNewExecute", {
    ...query,
    language: store.state.lang.key
  });
}

export async function bizumRefund(query: TransactionExecute): Promise<BizumRefundResult> {
  return await postServiceCall("bizumRefund", {
    ...query,
    language: store.state.lang.key
  });
}

export async function getTransactionInfo(query: TransactionInfoQuery): Promise<TransactionInfoResult> {
  return await postServiceCall("transactionInfo", {
    ...query,
    language: store.state.lang.key
  });
}

export function getFileName(
  fileType: TXFileType,
  companyName: string,
  branchName: string,
  from: string,
  to: string
): string {
  let baseName: string;
  switch (fileType.toLowerCase()) {
    case "statistics":
      baseName = "Estadísticas";
      break;
    case "resume":
      baseName = "Resumen";
      break;
    case "listing":
      baseName = "Transacciones";
      break;
    default:
      baseName = "Transacciones";
      break;
  }
  return util.cleanFilename(
    `${baseName} ${companyName} - ${branchName} del ${util.displayISODate(from)} al ${util.displayISODate(to)}`
  );
}

// tslint:disable-next-line:max-line-length
export async function downloadTxnFile(
  query: TransactionQuery,
  companyName: string,
  branchName: string,
  fileType: TXFileType
): Promise<void> {
  const data = await downloadCall("transactionDownload", true, { ...query, fileType, language: store.state.lang.key });
  download.exportBlob(getFileName(fileType, companyName, branchName, query.from, query.to), data as Blob);
}
